import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-white/10 bg-navy-900" data-id="element-135" data-mp="1dr1f9lwgpvek">
      <div className="mx-auto flex max-w-content flex-col gap-6 px-4 py-12 sm:px-6" style={{
      paddingTop: "8px",
      paddingBottom: "8px",
      marginTop: "0px",
      marginBottom: "0px"
    }} data-id="element-136" data-mp="3r7zltgib8e8m">
        <p className="font-display text-sm font-bold uppercase tracking-[0.18em] text-white" data-id="element-137" data-mp="3hj7y5kka8g3i">
          The Argentine Mindset © 2026  <span className="text-white/40" data-id="element-138" data-mp="3difpotj8if8a">|</span> All Rights
          Reserved
        </p>
        <p className="max-w-3xl text-xs leading-relaxed text-white/45" data-id="element-139" data-mp="38gyqr3kb92uc">
          <span className="font-semibold text-white/60" data-id="element-140" data-mp="33i5d9b50xbu6">Disclaimer:</span> Results vary by
          individual. This is educational content. The Argentine Mindset is not a guarantee
          of income or success, but a system to improve mindset and decision-making. Your
          results depend on your effort.
        </p>
        <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-white/10 pt-6 text-sm text-white/60" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        paddingLeft: "8px",
        paddingRight: "8px",
        alignItems: "flex-start",
        justifyContent: "center"
      }} data-id="element-141" data-mp="wtik39rekybv">
          <a href="mailto:support@theargentinemindset.com" className="transition-colors duration-200 ease-smooth hover:text-celeste-300" data-id="element-142" data-mp="vv1zxsqn5c38">
            soporte@kodadigital.shop
          </a>
          <a href="#" className="transition-colors duration-200 ease-smooth hover:text-celeste-300" data-id="element-143" data-mp="1ojfws55zu2d7">
            Privacy Policy
          </a>
          <a href="#" className="transition-colors duration-200 ease-smooth hover:text-celeste-300" data-id="element-144" data-mp="1esbk5c3sitlj">
            Terms of Service
          </a>
        </nav>
      </div>
    </footer>;
}